class PlanSelection {
  static readonly YEARLY = 0
  static readonly MONTHLY = 1

  static values () {
    return [
      PlanSelection.YEARLY,
      PlanSelection.MONTHLY
    ]
  }
}

export default PlanSelection
